// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "-legacy." + {"43":"725c40b6","311":"860e9f0b","331":"0fcfb611","413":"7af0dcbb","842":"bc446b9b","941":"14bd210c"}[chunkId] + ".js";
};